<template>
  <svg x="0px" y="0px" width="15px" height="25.378px" viewBox="0 0 15 25.378" enable-background="new 0 0 15 25.378" xml:space="preserve">
    <circle fill="#2A2525" cx="-98.531" cy="-7.311" r="24.375"/>
    <circle fill="#2A2525" cx="-98.531" cy="-7.311" r="20.719"/>
    <g>
      <g>
        <path fill="#2A2525" d="M12.654,25.378c-0.582,0-1.163-0.222-1.608-0.667L0.667,14.333c-0.889-0.889-0.889-2.329,0-3.217
          l10.45-10.449c0.889-0.889,2.327-0.889,3.215,0c0.892,0.889,0.892,2.329,0,3.217l-8.838,8.841l8.768,8.773
          c0.89,0.888,0.89,2.327,0,3.214C13.82,25.156,13.234,25.378,12.654,25.378z"/>
      </g>
    </g>    
  </svg>
</template>